import { render, staticRenderFns } from "./ValidationCounter.vue?vue&type=template&id=67fb7d04&"
import script from "./ValidationCounter.vue?vue&type=script&lang=js&"
export * from "./ValidationCounter.vue?vue&type=script&lang=js&"
import style0 from "./ValidationCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports